import { take, call, put, race, all, takeEvery, fork, select } from "redux-saga/effects";
import * as Statistics from './statisticsStore'
import { StatisticsModel, CountModel, DeletedStatisticsModel, CompanyContractModel, StatisticsFilterDto, StatisticsFilter } from "../StatisticsModel";
import { delay } from "redux-saga";
import * as api from '../../api/statisticsApi'
import { ApplicationState } from "../../store";

export function* watchStatisticSagas() {

    yield all([
        takeEvery(Statistics.ActionType.RequestStatisticsData, fetchStatisticsData),
    ])
};

const getCompanyId = (state: ApplicationState) => state.login.companyId;

/**
 * Fetch statistics
 */
export function* fetchStatisticsData(action: Statistics.RequestStatisticsDataAction) {

    let filters = action.filters;

    if (filters && filters.showOnlyOwnCompany) {
        const companyId = yield select(getCompanyId);

        filters = Object.assign({}, filters, { companyId });
    }

    // Get truck count
    const truckCount: CountModel = yield call(api.getTruckCount, filters);

    // Get unit count
    const unitCount: CountModel = yield call(api.getUnitCount, filters);

    // Get deleted units
    const deletedUnits: DeletedStatisticsModel = yield call(api.getDeletedUnits, filters);

    // Get deleted trucks
    const deletedTrucks: DeletedStatisticsModel = yield call(api.getDeletedTrucks, filters);

    const unitContracts: CompanyContractModel[] = yield call(api.getUnitContracts, filters);

    const truckContracts: CompanyContractModel[] = yield call(api.getTruckContracts, filters);

    // Build statistics model
    const statisticsData: StatisticsModel = {
        truckCount,
        unitCount,
        deletedUnits,
        deletedTrucks,
        unitContracts,
        truckContracts
    }

    // Send data to store.
    yield put(Statistics.actionCreators.receivedStatisticsData(statisticsData))
}



// WEBPACK FOOTER //
// ./src/statistics/store/sagas.ts